module.exports = __webpack_public_path__ + "img/19@2x.7592a6fe.png";